// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import dayjs from 'dayjs';
import { addCommas, removeNonNumeric } from '../../../utils/commonUtils';

type CheckedSessionStorage = {
  checked_right_strikers: string,
};

type CheckedRightStrikers = {
  right_strikers_attributes: any,
};

type CheckBoxEvent = {
  target: {
    id: number,
    checked: boolean,
  },
};

export default class SelectMembersView extends JQueryView {
  establishAt: string;
  checkedSessionStorage: CheckedSessionStorage;
  userId: number;

  constructor(establishAt: string, userId: number) {
    super('.simple_form');

    this.establishAt = establishAt;
    this.initDateRangePicker(this.$el);

    // 電磁的招集通知のトグルボタンのvalueが設定されない問題対応。本来はviewで設定すべき
    $('input[id$="is_electric_send"][type="checkbox"]').val('on');

    this.userId = userId;

    // $FlowFixMe
    this.checkedSessionStorage = (sessionStorage: CheckedSessionStorage);

    this.restoreInputs();
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        minDate: this.establishAt,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  buildCheckedRightStrikers = () => {
    const FORM_PREFIX = 'company_right_strike_members_form';
    const MEMBERS_PREFIX = 'right_strikers_attributes';
    const rightholdersCount = $('table.rightholders-table tbody tr').length;
    const checkedRightStrikers = {
      user_id: this.userId,
      select_right_type_id: $(`#${FORM_PREFIX}_select_right_type_id`).val(),
      select_stock_type_id: $(`#${FORM_PREFIX}_select_stock_type_id`).val(),
      right_strikers_attributes: {},
    };

    for (let i = 0; i < rightholdersCount; i++) {
      const checked = $(`#${FORM_PREFIX}_${MEMBERS_PREFIX}_${i}_checked`)[0]
        .checked;
      if (checked) {
        checkedRightStrikers.right_strikers_attributes[String(i)] = {
          checked: 'true',
          stock_acquisition_date: $(
            `#${FORM_PREFIX}_${MEMBERS_PREFIX}_${i}_stock_acquisition_date`,
          ).val(),
          strike_rights_count: $(
            `#${FORM_PREFIX}_${MEMBERS_PREFIX}_${i}_strike_rights_count`,
          ).val(),
          grant_stocks_count: $(
            `#${FORM_PREFIX}_${MEMBERS_PREFIX}_${i}_grant_stocks_count`,
          ).val(),
          is_electric_send: $(
            `#${FORM_PREFIX}_${MEMBERS_PREFIX}_${i}_is_electric_send`,
          ).val(),
        };
      } else {
        checkedRightStrikers.right_strikers_attributes[String(i)] = {};
      }
    }
    return checkedRightStrikers;
  };

  @on({ event: 'change', selector: 'input[name="all_checked"]' })
  onChangeAllCheck() {
    const allChecked = $('input[name="all_checked"]').prop('checked');
    if (allChecked) {
      $('input[type=checkbox][class~="form-check-input"]').prop(
        'checked',
        true,
      );
      $('input[id$="stock_acquisition_date"]').prop('disabled', false);
      $('input[id$="strike_rights_count"]').prop('disabled', false);
      $('input[id$="grant_stocks_count"]').prop('disabled', false);
      $('input[id$="is_electric_send"]').prop('disabled', false);
      // daterangepickerの背景色変更暫定措置
      $('div.input-group-append').css('background-color', '#ffffff');
    } else {
      $('input[type=checkbox][class~="form-check-input"]').prop(
        'checked',
        false,
      );
      $('input[id$="stock_acquisition_date"]').prop('disabled', true);
      $('input[id$="strike_rights_count"]').prop('disabled', true);
      $('input[id$="grant_stocks_count"]').prop('disabled', true);
      $('input[id$="is_electric_send"]').prop('disabled', true);
      // daterangepickerの背景色変更暫定措置
      $('div.input-group-append').css('background-color', '#f4f4f4');
    }
    $('input[id$="stock_acquisition_date"]').removeClass('is-invalid');
    $('input[id$="strike_rights_count"]').removeClass('is-invalid');
    $('input[id$="grant_stocks_count"]').removeClass('is-invalid');
    $('small').remove();
  }

  @on({
    event: 'change',
    selector: 'input[type=checkbox][class~="target-check"]',
  })
  onChangeTargetCheck(event: CheckBoxEvent) {
    const trElement = $(`tr:has(input#${event.target.id})`);
    trElement
      .find('input[id$="stock_acquisition_date"]')
      .prop('disabled', !event.target.checked);
    trElement
      .find('input[id$="strike_rights_count"]')
      .prop('disabled', !event.target.checked);
    trElement
      .find('input[id$="grant_stocks_count"]')
      .prop('disabled', !event.target.checked);
    trElement
      .find('input[id$="is_electric_send"]')
      .prop('disabled', !event.target.checked);
    trElement
      .find('input[id$="stock_acquisition_date"]')
      .removeClass('is-invalid');
    trElement
      .find('input[id$="strike_rights_count"]')
      .removeClass('is-invalid');
    trElement.find('input[id$="grant_stocks_count"]').removeClass('is-invalid');
    trElement.find('small').remove();
    if (event.target.checked) {
      // daterangepickerの背景色変更暫定措置
      trElement
        .find('div.input-group-append')
        .css('background-color', '#ffffff');
    } else {
      // daterangepickerの背景色変更暫定措置
      trElement
        .find('div.input-group-append')
        .css('background-color', '#f4f4f4');
    }
  }

  restoreInputs() {
    // ブラウザバック時に行使対象者の入力項目を復元
    if (this.checkedSessionStorage.checked_right_strikers) {
      const checkedRightStrikers: CheckedRightStrikers = JSON.parse(
        this.checkedSessionStorage.checked_right_strikers,
      );

      Object.keys(checkedRightStrikers.right_strikers_attributes).forEach(
        stakeholderKey => {
          const stakeholder =
            checkedRightStrikers.right_strikers_attributes[stakeholderKey];
          const checked = stakeholder.checked
            ? Boolean(stakeholder.checked)
            : false;
          if (checked) {
            const ID_PREFIX =
              'company_right_strike_members_form_right_strikers_attributes_';
            const trElement = $(
              `tr:has(input#${ID_PREFIX}${stakeholderKey}_checked)`,
            );

            trElement.find('input[id$="checked"]').prop('checked', 'checked');
            trElement
              .find('input[id$="stock_acquisition_date"]')
              .prop('disabled', !checked);
            trElement
              .find('input[id$="strike_rights_count"]')
              .prop('disabled', !checked);
            trElement
              .find('input[id$="grant_stocks_count"]')
              .prop('disabled', !checked);
            trElement
              .find('input[id$="is_electric_send"]')
              .prop('disabled', !checked);
            trElement
              .find('input[id$="stock_acquisition_date"]')
              .val(stakeholder.stock_acquisition_date);
            trElement
              .find('input[id$="strike_rights_count"]')
              .val(stakeholder.strike_rights_count);
            trElement
              .find('input[id$="grant_stocks_count"]')
              .val(stakeholder.grant_stocks_count);
            trElement.find('input[id$="is_electric_send"]').checked =
              stakeholder.is_electric_send == 'on';
          }
        },
      );
    } else {
      if ($('.invalid-feedback').length == 0) {
        // エラーがない場合チェックを全てオフにする
        $('input[type=checkbox][class~="form-check-input"]').prop(
          'checked',
          false,
        );
      } else {
        // エラーがある場合、チェックしたtr配下のinputのdisabledを全解除
        $('tr:has(small.invalid-feedback) input').prop('disabled', false);
      }
    }
    // 電磁的招集通知のトグルボタンのvalueが設定されない問題対応。本来はviewで設定すべき
    $('input[id$="is_electric_send"][type="checkbox"]').val('on');
  }

  @on({
    event: 'change',
    selector: 'input',
  })
  onInputChange() {
    sessionStorage.setItem(
      'checked_right_strikers',
      JSON.stringify(this.buildCheckedRightStrikers()),
    );
  }

  @on({
    event: 'focus',
    selector: 'input',
  })
  onInputFocus(event: Event) {
    if ($(event.target).hasClass('is-invalid')) {
      $(event.target)
        .parent()
        .find('span.input-group-text')
        .addClass('is-invalid');
    }
  }

  @on({
    event: 'blur',
    selector: 'input',
  })
  onInputBlur(event: Event) {
    if (!$(event.target).hasClass('is-invalid')) {
      $(event.target)
        .parent()
        .find('span.input-group-text')
        .removeClass('is-invalid');
    }
  }

  @on({
    event: 'input',
    selector: 'input.comma-numeric',
  })
  onInputCommaNumeric(event: Event) {
    const eventTarget = $(event.target);
    eventTarget.val(addCommas(removeNonNumeric(eventTarget.val())));
  }
}
